import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["noPadding"];
import React from 'react';
import { CnLayoutSection as UICnLayoutSection } from "../../components/cn-layout";
import { executeFunction, getLowCodeCoreUtil, isArrayNotEmpty } from "../../common/util/util";
import "./view.scss";
import isPlainObject from 'lodash/isPlainObject';
var CnLayoutSection = function CnLayoutSection(props) {
  var _getLowCodeCoreUtil;
  var _ref = props || {},
    children = _ref.children,
    normalStyle = _ref.normalStyle,
    _layout = _ref._layout,
    extra = _ref.extra,
    _context = _ref._context,
    handleProps = _ref.handleProps;
  var _ref2 = _layout || {},
    componentSlot = _ref2.componentSlot;
  var state = _context === null || _context === void 0 ? void 0 : _context.state;
  var _ref3 = normalStyle || {},
    noPadding = _ref3.noPadding,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
  var extraDom = (_getLowCodeCoreUtil = getLowCodeCoreUtil('util.makeButtons')) === null || _getLowCodeCoreUtil === void 0 ? void 0 : _getLowCodeCoreUtil({
    buttons: extra === null || extra === void 0 ? void 0 : extra.map(function (item) {
      var realChildren = item === null || item === void 0 ? void 0 : item.children;
      if (typeof (item === null || item === void 0 ? void 0 : item.children) === 'function') {
        realChildren = executeFunction(item.children, {}, state);
      }
      return _extends({}, item, {
        size: 'small',
        position: getLowCodeCoreUtil('enumMap.ButtonPosition.tileRightButton'),
        children: realChildren
      });
    }),
    _context: _context,
    state: state,
    recordDataSource: {}
  });
  if (isArrayNotEmpty(extraDom)) {
    extraDom = /*#__PURE__*/React.createElement("div", {
      className: 'cn-layout-section-extra'
    }, extraDom);
  }
  var getExtraDom = function getExtraDom() {
    if (isArrayNotEmpty(componentSlot)) {
      return componentSlot.map(function (item, index) {
        return /*#__PURE__*/React.cloneElement(item, {
          existPosition: 'SectionExtra'
        });
      });
    }
    if (componentSlot) {
      return componentSlot;
    }
    return null;
  };
  var extraProps = {};
  if (noPadding) {
    extraProps.style = {
      paddingLeft: 0,
      paddingRight: 0
    };
  }
  extraProps = _extends({}, extraProps, rest);
  if (typeof handleProps === 'function') {
    var tempProps = executeFunction(handleProps, _extends({}, extraProps), _context === null || _context === void 0 ? void 0 : _context.state);
    if (isPlainObject(tempProps)) {
      extraProps = tempProps;
    }
  }
  return /*#__PURE__*/React.createElement(UICnLayoutSection, _extends({
    extra: extraDom
  }, extraProps), getExtraDom(), children);
};
CnLayoutSection.displayName = 'CnLayoutSection';
export default CnLayoutSection;
export { CnLayoutSection };